import React, { lazy, Suspense } from "react";
import { Route, Routes } from "react-router-dom";
import Home from './pages/Home';
import About from './pages/About'
import Service from './pages/Service';
import InstantLoan from './pages/InstantLoan';
import EmergencyLoan from './pages/EmergencyLoan';
import PersonalLoan from './pages/PersonalLoan';
import ContactUs from './pages/ContactUs';
import ApplyNow from './pages/ApplyNow';
import Paynow from './pages/Paynow';
import { Provider } from 'react-redux';
import store from './store/store';
import Layout1 from './Layout1';
import NewDashboard from './pages/journey-pages/NewDashboard';
import ApplicationStep from './pages/journey-pages/ApplicationStep';
import Thankyou from './pages/journey-pages/Thankyou';
import NotEligible from './pages/journey-pages/NotEligible';
import Dashboard from './pages/journey-pages/Dashboard';
import LoanDetails from './pages/journey-pages/LoanDetails';
import Support from './pages/journey-pages/Support';
import UserProfile from './pages/journey-pages/UserProfile';
import LoanHistory from './pages/journey-pages/LoanHistory';
import { ToastContainer } from 'react-toastify';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsAndCondition from './pages/TermsAndConditions';
import Ekyc from './pages/journey-pages/Ekyc';
import NotFound from "./pages/NotFound";
import PrivateRoute from "./component/PrivateRoute";
import DeletionPolicy from "./pages/DeletionPolicy";







// end


const showmessage = async (message) => {
  try {
    const x = document.getElementById("snackbar");
    if (x) {
      x.className = "show"; // Add "show" class to make the snackbar visible
      x.innerText = message;
      setTimeout(function () {
        x.className = x.className.replace("show", ""); // Hide snackbar after 3 seconds
      }, 3000);
    }
  } catch (error) {
    console.log(error);
  }
};


function Router() {
  return (
    <>
      

        <Provider store={store}>
          <ToastContainer
            position="top-right"
            autoClose={3000}
            hideProgressBar={false}
            newestOnTop={false}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
          />

          <Routes>
              <Route path="*" element={<NotFound />} />
            <Route path='/' element={<Home />}></Route>
        <Route path="/about-us" element={<About />} />
        <Route path="/services" element={<Service/>} /> 
        <Route path="/services/instant-loan" element={<InstantLoan/>} />
        <Route path="/services/emergency-loan" element={<EmergencyLoan/>} />
        <Route path="/services/personal-loan" element={<PersonalLoan/>} />
        <Route path='/contact-us' element={<ContactUs/>}></Route> 
        <Route path='/apply-now' element={<ApplyNow/>}></Route>
        <Route path='/pay-now' element={<Paynow/>}></Route>
        <Route path='/privacy-policy' element={<PrivacyPolicy/>}/>
        <Route path='/terms-and-conditions' element={<TermsAndCondition/>}/>
        <Route path='/deletion-policy' element={<DeletionPolicy/>}/>
        

    <Route element={<PrivateRoute />}>
    
    <Route element={<Layout1 />}>
      <Route path="/journey" element={<NewDashboard />} />
      <Route path="/journey/application" element={<ApplicationStep />} />
      <Route path="/journey/congratulations" element={<Thankyou />} />
      <Route path="/journey/not-eligible" element={<NotEligible />} />
      <Route path="/journey/dashboard" element={<Dashboard />} />
      <Route path="/journey/loan-detail" element={<LoanDetails />} />
      <Route path="/journey/support-detail" element={<Support />} />
      <Route path="/journey/user-profile" element={<UserProfile />} />
      <Route path="/journey/loan-history" element={<LoanHistory />} />
    </Route>

  </Route>

  </Routes>

            
        </Provider>
      
    </>
  );
}

export default Router;
